import { createSlice } from '@reduxjs/toolkit';

const NAME = 'user';
const INITIAL_STATE = null;

const userReducer = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        setActiveUser: (state, action) => {
            return {
                ...state,
                ...action.payload,
                activeSince: +new Date()
            };
        },
        clearActiveUser: () => {
            return INITIAL_STATE;
        },
    }
});

export const { setActiveUser, clearActiveUser } = userReducer.actions;
export const selectUser = (state) => state.user;
export default userReducer.reducer;
